"use client";
/** Emits the fleet `signed_in` event once per browser session for the server-verified identity. */
import { useEffect } from "react";
import { useTrack } from "@owlcat/app-shell";
import { signedInOnce } from "../analytics";

export function SignedInBeacon({ identityId }: { identityId: string | null | undefined }) {
  const track = useTrack();
  useEffect(() => {
    signedInOnce(identityId, track);
  }, [identityId, track]);
  return null;
}
